// extracted by mini-css-extract-plugin
module.exports = {"footerStyle":"Footer_footerStyle__2OXSz","footerContant":"Footer_footerContant___25AG"};